<div class="middle-column d-flex flex-column">
  <div class="search-results block">
    <!--        <div class="search-results-title" *ngIf="totalAmount">-->
    <!--            Found {{ totalAmount }} results:-->
    <!--        </div>-->
    <div class="search-results-wrapper">
      <ng-container *ngIf="isPeople">
        <app-loader-2 *ngIf="!people"></app-loader-2>
        <app-people-search-result
          class="search-results-item d-flex align-items-center"
          [user]="user"
          (connect)="onProfileConnect($event)"
          (unconnect)="onProfileDisconnect($event)"
          (remove)="onProfileDisconnect($event)"
          *ngFor="let user of people"
        >
        </app-people-search-result>
      </ng-container>

      <ng-container *ngIf="isOrganizations">
        <app-loader-2 *ngIf="!organizations"></app-loader-2>
        <app-organization-search-result
          [organization]="organization"
          (subscribe)="onOrganizationSubscribe($event)"
          (unsubscribe)="onOrganizationUnSubscribe($event)"
          *ngFor="let organization of organizations"
        >
        </app-organization-search-result>
      </ng-container>

      <ng-container *ngIf="isDiscussions">
        <app-loader-2 *ngIf="!discussions"></app-loader-2>
        <app-discussion-search-result [discussion]="discussion" *ngFor="let discussion of discussions">
        </app-discussion-search-result>
      </ng-container>

      <ng-container *ngIf="isGroups">
        <app-loader-2 *ngIf="groups.isLoading"></app-loader-2>
        <app-group-search-result
          [group]="group"
          (join)="onGroupJoin(group)"
          *ngFor="let group of groups.items"
        ></app-group-search-result>
      </ng-container>

      <ng-container *ngIf="isClubs">
        <app-loader-2 *ngIf="!clubs; else clubsWrap"></app-loader-2>
        <ng-template #clubsWrap>
          <div
            class="ceils-content-wrapper business-block d-flex flex-wrap flex-column flex-md-row justify-content-md-between"
          >
            <app-business-club-item
              class="ceil-article-item business-block-item"
              [club]="group"
              *ngFor="let group of clubs"
            >
            </app-business-club-item>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="isEvents">
        <app-loader-2 *ngIf="!events"></app-loader-2>
        <app-event-search-result [event]="event" *ngFor="let event of events"> </app-event-search-result>
      </ng-container>

      <ng-container *ngIf="isMembers">
        <app-loader-2 *ngIf="!members"></app-loader-2>
        <app-people-search-result
          class="search-results-item d-flex align-items-center"
          [user]="user"
          (connect)="onProfileConnect($event)"
          (unconnect)="onProfileDisconnect($event)"
          (remove)="onProfileDisconnect($event)"
          *ngFor="let user of members"
        >
        </app-people-search-result>
      </ng-container>
    </div>

    <app-page-counter
      *ngIf="amountOfPages"
      [currentPage]="currentPage"
      [amountOfPages]="amountOfPages"
      (setPage)="onSetPage($event)"
      class="mt-md-auto"
    ></app-page-counter>
  </div>
</div>
